/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/camelcase */
import {
  Checkbox,
  Chip,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import TableItems, { TableCell, TableRow } from 'components/TableItems';
import i18n from 'i18n';
import { getAllClientsRequest } from 'modules/clients/actions';
import {
  BulkClientsFields,
  ListBulkClientsProps,
} from 'modules/environments/interfaces';

import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import ApplicationState from 'store/interfaces';
import CheckIcon from '@material-ui/icons/Check';
import {
  editBulkClientsRequest,
  getBulkClientsRequest,
} from 'modules/environments/actions';
import { Formik, Form } from 'formik';
import Button from 'components/Button';
import { modalClose, modalOpen } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import { useTableFilters } from 'hooks/useTableFilters';
import TitleDivider from 'components/TitleDivider';
import DynamicTextField from 'components/DynamicTextField';
import InputAdornmentChip from 'components/InputAdornmentChip';
import clsx from 'clsx';
import { SearchBar } from 'components/SearchBar';
import VerificationCode from 'components/VerificationCode';
import styles from '../styles';
import screenFields from '../screenFields';
import schema from '../schema';
import { initialQuery } from '..';

interface Props {
  isLoadingBulkClients: boolean;
  bulkClients: ListBulkClientsProps;
  verificationCodeRef: React.MutableRefObject<string[]>;
  setVerificationCode: React.Dispatch<React.SetStateAction<string[]>>;
  editBulkClientsRequest: (props) => void;
  modalClose: () => void;
  modalOpen: (props: ModalFields) => void;
  getBulkClientsRequest: (props) => void;
}

const EmailAdminEdit = ({
  isLoadingBulkClients,
  bulkClients,
  verificationCodeRef,
  setVerificationCode,
  editBulkClientsRequest,
  modalClose,
  modalOpen,
  getBulkClientsRequest,
}: Props) => {
  interface ClientInfo {
    client_uuid: string;
    name: string;
  }
  const [selectedAll, setSelectedAll] = React.useState(false);
  const [replaceAll, setReplaceAll] = React.useState(false);
  const [emailsToAdd, setEmailsToAdd] = React.useState<string>('');
  const [checks, setChecks] = React.useState<ClientInfo[]>([]);
  const [activeAll, setActiveAll] = React.useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const classes = makeStyles(styles)();
  const {
    query,
    searchValue,
    itemOrder,
    handleOrder,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    setSearchValue,
  } = useTableFilters(initialQuery);

  const getBulkClients = () => {
    getBulkClientsRequest({
      id,
      query: { ...query },
    });
  };

  const headers = [
    {
      key: 'nome',
      i18n: 'CLIENT_NAME_KEY',
      order: true,
    },
    {
      key: 'email_admin',
      i18n: 'Email',
      order: true,
    },
  ];

  React.useEffect(() => {
    getBulkClients();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getBulkClientsRequest, query]);

  const handleAllCheck = () => {
    if (!selectedAll) {
      const clientsInfo: ClientInfo[] = bulkClients?.results.map(item => ({
        client_uuid: item?.client_uuid || '',
        name: item?.name || '',
      }));
      setChecks(clientsInfo);
    } else {
      setChecks([]);
    }
    setSelectedAll(!selectedAll);
  };

  const handleCheck = (uuid: string, name: string) => {
    const findCheckId = checks.find(item => item?.client_uuid === uuid);
    if (!findCheckId) {
      setChecks([...checks, { client_uuid: uuid, name }]);
    } else {
      const filteredChecks = checks.filter(item => item?.client_uuid !== uuid);
      setChecks(filteredChecks);
    }
  };

  const clientUuids: string[] = checks.map(client => client?.client_uuid);
  const handleConfirm = (values: any) => {
    const verificationCodeToSend = verificationCodeRef.current;
    editBulkClientsRequest({
      id,
      dataValues: {
        operator_data: {
          action_reason: values?.action_reason,
          restricted_action_code: verificationCodeToSend.join(''),
        },
        clients_data: [
          {
            cli_uuids: clientUuids,
            email_admin: {
              email_admin: emailsToAdd,
              replace_all: replaceAll,
            },
          },
        ],
      },
    });
    modalClose();
  };

  const handleSubmit = (values: any) => {
    setVerificationCode(Array(6).fill(''));
    editBulkClientsRequest({
      id,
      dataValues: {
        operator_data: {
          action_reason: values?.action_reason,
        },
        clients_data: [
          {
            cli_uuids: clientUuids,
            email_admin: {
              email_admin: emailsToAdd,
              replace_all: replaceAll,
            },
          },
        ],
      },
    });
    modalOpen({
      title: i18n.t('VERIFICATION_CODE_KEY'),
      content: (
        <VerificationCode
          length={6}
          setVerificationCode={setVerificationCode}
          onRetry={() => {
            editBulkClientsRequest({
              id,
              dataValues: {
                operator_data: {
                  action_reason: values?.action_reason,
                },
                clients_data: [
                  {
                    cli_uuids: clientUuids,
                    email_admin: {
                      email_admin: emailsToAdd,
                      replace_all: replaceAll,
                    },
                  },
                ],
              },
            });
          }}
          onConfirm={() => {
            handleConfirm(values);
          }}
        />
      ),
      fullWidth: true,
    });
  };

  const emailsArray: string[] = emailsToAdd.split(',');

  return (
    <Grid container spacing={2} className={classes.container}>
      <Grid container>
        <Grid container className={classes.valuesForm} spacing={2}>
          <Formik
            initialValues={{ email_admin: '' }}
            onSubmit={handleSubmit}
            enableReinitialize
            validateOnBlur
            validateOnChange
          >
            {({ values }) => (
              <InputAdornmentChip
                styles={{
                  padding: '8px 7px',
                }}
                gridXs={7}
                label={i18n.t('ADMIN_EMAIL_KEY')}
                stateKey="email_admin"
                values={values?.email_admin?.split(',').filter(Boolean) || []}
                setFieldValue={(key, value) => {
                  setEmailsToAdd(value);
                }}
              />
            )}
          </Formik>
          <Grid container justify="center" spacing={2}>
            <Grid
              item
              className={clsx(classes.optionsEmailAdmin, {
                [classes.optionsEmailAdminSelected]: replaceAll,
              })}
              onClick={() => {
                setReplaceAll(true);
              }}
            >
              <Checkbox
                onChange={() => {
                  setReplaceAll(true);
                }}
                checked={replaceAll}
                id="replace-email-admin"
                icon={<CheckIcon className={classes.ghostCheckIcon} />}
                checkedIcon={<CheckIcon className={classes.checkIcon} />}
              />
              <Typography
                className={clsx(classes.activeAllText, {
                  [classes.emailAdminOptionTextSelected]: replaceAll,
                })}
              >
                {i18n.t('REPLACE_KEY')}
              </Typography>
            </Grid>
            <Typography className={classes.activeAllText}>
              {i18n.t('OR_KEY')}
            </Typography>
            <Grid
              item
              className={clsx(classes.optionsEmailAdmin, {
                [classes.optionsEmailAdminSelected]: !replaceAll,
              })}
              onClick={() => {
                setReplaceAll(false);
              }}
            >
              <Checkbox
                onChange={() => {
                  setReplaceAll(false);
                }}
                checked={!replaceAll}
                id="add-email-admin"
                icon={<CheckIcon className={classes.ghostCheckIcon} />}
                checkedIcon={<CheckIcon className={classes.checkIcon} />}
              />
              <Typography
                className={clsx(classes.activeAllText, {
                  [classes.emailAdminOptionTextSelected]: !replaceAll,
                })}
              >
                {i18n.t('ADD_KEY')}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          justify="flex-start"
          className={classes.checkboxActivateAllVirtualizer}
        >
          <Checkbox
            onChange={() => {
              setActiveAll(!activeAll);
              setChecks([]);
            }}
            checked={activeAll}
            id="change-all-clients"
          />
          <Typography className={classes.activeAllText}>
            {i18n.t('BULK_CLIENTS.CONFIG_EMAIL_ADMIN_IN_ALL_CLIENTS_KEY')}
          </Typography>
        </Grid>
        {!activeAll && (
          <>
            <SearchBar
              id="search-client"
              isLoading={isLoadingBulkClients}
              searchValue={searchValue}
              handleSearch={handleSearch}
              setSearchValue={setSearchValue}
            />
            <TableItems
              header={
                <>
                  <TableCell className={classes.checkboxCell}>
                    <Checkbox
                      onChange={handleAllCheck}
                      id="select-all-clients-environment"
                    />
                  </TableCell>
                  {headers.map(item => (
                    <TableCell
                      key={item?.key}
                      order={item?.order}
                      handleOrder={() =>
                        item?.order ? handleOrder(item?.key) : null
                      }
                      markOderItem={itemOrder === item?.key}
                    >
                      {i18n.t(item?.i18n)}
                    </TableCell>
                  ))}
                </>
              }
              renderItems={(item: BulkClientsFields, index) => (
                <TableRow key={index}>
                  <TableCell className={classes.checkboxCell}>
                    <Checkbox
                      onChange={() =>
                        handleCheck(item?.client_uuid || '', item?.name || '')
                      }
                      checked={
                        !!checks.find(
                          check => check?.client_uuid === item?.client_uuid
                        )
                      }
                    />
                  </TableCell>
                  <TableCell>{item?.name}</TableCell>
                  <TableCell>
                    {item?.email_admin.email_admin.replace(/,/g, ', ')}
                  </TableCell>
                </TableRow>
              )}
              isLoading={isLoadingBulkClients}
              data={bulkClients}
              overrideRowsCount={10}
              onChangeLimit={handleLimitChange}
              onChangePage={handlePageChange}
              notFoundText={i18n.t('NO_CLIENT_KEY')}
              smallLoading={true}
            />
          </>
        )}
      </Grid>
      <Grid container justify="flex-end" className={classes.buttons}>
        <Button
          id="next-button"
          submitButton
          disabled={
            emailsToAdd.length === 0 || (checks.length === 0 && !activeAll)
          }
          onClick={() => {
            modalOpen({
              title: i18n.t('BULK_CLIENTS.CONFIRM_CHANGE_EMAIL_ADMIN_KEY'),
              content: (
                <>
                  <Grid container justify="flex-start">
                    <Typography style={{ fontSize: 12, marginBottom: 12 }}>
                      {replaceAll
                        ? i18n.t('BULK_CLIENTS.EMAILS_TO_REPLACE_KEY')
                        : i18n.t('BULK_CLIENTS.EMAILS_TO_ADD_KEY')}
                    </Typography>
                  </Grid>
                  <Grid container justify="flex-start">
                    {emailsArray.map((email, index) => (
                      <Chip style={{ margin: 2 }} key={index} label={email} />
                    ))}
                  </Grid>
                  {!activeAll ? (
                    <>
                      <Grid container justify="center">
                        <Typography
                          style={{ fontSize: 12, margin: '12px 0px' }}
                        >
                          {i18n.t(
                            'BULK_CLIENTS.CONFIRM_CHANGE_EMAIL_ADMIN_IN_CLIENTS_KEY'
                          )}
                        </Typography>
                      </Grid>
                      <TableItems
                        header={
                          <>
                            <TableCell className={classes.tableRow}>
                              {i18n.t('CLIENT_NAME_KEY')}
                            </TableCell>
                          </>
                        }
                        renderItems={(item: BulkClientsFields, index) => (
                          <TableRow key={index}>
                            <TableCell>{item?.name}</TableCell>
                          </TableRow>
                        )}
                        isLoading={isLoadingBulkClients}
                        data={{
                          count: 0,
                          next: '',
                          previous: '',
                          results: checks,
                        }}
                        onChangeLimit={handleLimitChange}
                        onChangePage={handlePageChange}
                        notFoundText={i18n.t('NO_CLIENT_KEY')}
                        notFooter
                        smallLoading={true}
                      />
                    </>
                  ) : (
                    <Grid container justify="center">
                      <Typography style={{ fontSize: 12, margin: '12px 0px' }}>
                        {i18n.t(
                          'BULK_CLIENTS.CONFIRM_CHANGE_EMAIL_ADMIN_IN_ALL_CLIENTS_KEY'
                        )}
                      </Typography>
                    </Grid>
                  )}
                  <TitleDivider
                    overrideClasses={{
                      title: { margin: '12px 4px 8px 4px', fontSize: 12 },
                    }}
                  >
                    {i18n.t('BULK_CLIENTS.SET_CONNECTION_TYPE_TO_CONFIRM_KEY')}
                  </TitleDivider>
                  <Formik
                    initialValues={{ action_reason: '' }}
                    enableReinitialize
                    validationSchema={schema}
                    validateOnChange
                    validateOnBlur
                    onSubmit={handleSubmit}
                  >
                    {({ setFieldValue, errors, values, submitForm }) => {
                      return (
                        <React.Fragment>
                          <Form>
                            <Grid container>
                              <Grid
                                container
                                spacing={2}
                                className={classes.fields}
                              >
                                <DynamicTextField
                                  {...screenFields[0]}
                                  setFieldValue={setFieldValue}
                                  value={values?.action_reason}
                                  errors={errors}
                                />
                              </Grid>
                            </Grid>
                            <Grid
                              container
                              justify="flex-end"
                              style={{ marginTop: 12 }}
                            >
                              <Button
                                submitButton
                                id="confirm-button"
                                onClick={submitForm}
                                isLoading={isLoadingBulkClients}
                              >
                                {i18n.t('CONTINUE_KEY')}
                              </Button>
                              <Button
                                id="cancel-button"
                                variant="outlined"
                                onClick={modalClose}
                              >
                                {i18n.t('CANCEL_KEY')}
                              </Button>
                            </Grid>
                          </Form>
                        </React.Fragment>
                      );
                    }}
                  </Formik>
                </>
              ),
            });
          }}
        >
          {i18n.t('NEXT_KEY')}
        </Button>
        <Button id="cancel-button" variant="outlined" onClick={modalClose}>
          {i18n.t('CLOSE_KEY')}
        </Button>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({
  environments: { environmentSelected, bulkClients, isLoadingBulkClients },
}: ApplicationState) => ({
  environmentSelected,
  bulkClients,
  isLoadingBulkClients,
});

export default connect(mapStateToProps, {
  getAllClientsRequest,
  modalClose,
  editBulkClientsRequest,
  modalOpen,
  getBulkClientsRequest,
})(EmailAdminEdit);
